module.exports = __webpack_public_path__ + "static/media/rag-flow-r.c02256d2.svg";